module.exports = __webpack_public_path__ + "img/collapse-list-arrow.c98b228d.svg";